import { hasModule } from '@/lib/modules';

/** Business types (`tenants.industry_key`) that get the clinic layouts: aesthetic clinic and dental clinic. */
const CLINIC_INDUSTRIES: readonly string[] = ['clinic', 'dental'];

export const isClinicIndustry = (industry: string | null | undefined): boolean =>
  industry != null && CLINIC_INDUSTRIES.includes(industry);

/** Business types (`tenants.industry_key`) that sell goods from stock and take no appointments. */
const NO_APPOINTMENT_INDUSTRIES: readonly string[] = ['retail', 'online_shop'];

export const usesAppointments = (industry: string | null | undefined): boolean =>
  industry == null || !NO_APPOINTMENT_INDUSTRIES.includes(industry);

export const isRetailIndustry = (industry: string | null | undefined): boolean => industry === 'retail';

/** Online shops sell through their order page (`/o/<slug>`): products, orders and slips, no bookings. */
export const isOnlineShopIndustry = (industry: string | null | undefined): boolean =>
  industry === 'online_shop';

/** Cafés and online shops that take orders: the shop opens on the order screen and the menu leads with orders and payment. */
export const isOrderFirstShop = (m: { tenant: { industry: string }; modules: readonly string[] }): boolean =>
  (m.tenant.industry === 'cafe' || isOnlineShopIndustry(m.tenant.industry)) &&
  hasModule(m.modules, 'table_ordering');

/** Drink shops and restaurants: they stock ingredients (milk, beans, cups), not goods for sale on a shelf. */
export const isDrinkShopIndustry = (industry: string | null | undefined): boolean =>
  industry === 'cafe' || industry === 'restaurant';

/** Types whose bookings name a table, court or room, not a staff member: "my bookings" is never the staff's work there. */
const RESOURCE_BOOKED_INDUSTRIES: readonly string[] = [
  'retail',
  'online_shop',
  'restaurant',
  'cafe',
  'court',
  'music_studio',
];

export const staffTakesBookings = (industry: string | null | undefined): boolean =>
  industry == null || !RESOURCE_BOOKED_INDUSTRIES.includes(industry);

/** Hair salons and barbers (`barber`: ร้านเสริมสวย/ทำผม/บาร์เบอร์, `salon`: ร้านสระผม/เฮดสปา): services there can carry options (shampoo, colour…). */
const SERVICE_OPTION_INDUSTRIES: readonly string[] = ['barber', 'salon'];

export const usesServiceOptions = (industry: string | null | undefined): boolean =>
  industry != null && SERVICE_OPTION_INDUSTRIES.includes(industry);
